
import * as React from 'react';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import { ErrorComponentProps } from './errorcomponent';
import { ErrorCSSStyle } from './errorcss';
import { RoutingFeatures } from '../routingfeature';
import { createBrowserHistory } from 'history';

export class ErrorViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
      this.onLoginClick = this.onLoginClick.bind(this);
    }

    draw(props: ErrorComponentProps, state: UIComponentState, cssStyle: ErrorCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={{display: "inline-block", width: "100%", height: "100%", textAlign: 'center'}}>
              <label style={{height: "40px", width: "100%", color: "#000000"}}>{"Oops Something went wrong, Please"}
              <u style={{cursor: "pointer"}} onClick={this.onLoginClick}>{" click here "}</u>
              {"to continue"}
              </label>
            </div>);
    }


    onLoginClick()
    {
      let history = createBrowserHistory();
      history.push("/crbt-web-portal/" + RoutingFeatures.HOME);

      window.location.reload(false);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/error/errortview.tsx